import { routes } from '@spot/shared';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { Button } from '../../components/ui/button';
import { Sheet, SheetCloseButton } from '../../components/ui/sheet';
import { useSession } from '../auth/session-gate';

/** T-804 (D38): confirm, then `DELETE /v1/me`; the session gate shows the final screen. */
export function DeleteAccountSheet({ onClose }: { onClose: () => void }) {
	const { t } = useTranslation();
	const { api, onAccountDeleted } = useSession();
	const remove = useMutation({
		mutationFn: () => api.call(routes.deleteMe),
		onSuccess: onAccountDeleted,
	});
	return (
		<Sheet title={t('account.delete_title')} onClose={onClose}>
			<div className="flex flex-col gap-3">
				<p className="text-body text-text-muted whitespace-pre-line">{t('account.delete_body')}</p>
				{remove.isError && (
					<p role="alert" className="text-body text-danger">
						{t('errors.generic_body')}
					</p>
				)}
				<Button
					variant="danger"
					disabled={remove.isPending}
					onClick={() => {
						remove.mutate();
					}}
				>
					{remove.isPending ? t('account.deleting') : t('account.delete_confirm')}
				</Button>
				<SheetCloseButton variant="secondary">{t('account.delete_keep')}</SheetCloseButton>
			</div>
		</Sheet>
	);
}
